import { Box, Typography } from '@mui/material';
import { Risks } from '../../types/WorkflowState';
import RiskIcon from './RiskIcon';

export interface RiskAnalysisProps {
  risks: Risks;
  loading?: boolean;
}

export function getRiskAnalysis({ risks, loading }: RiskAnalysisProps) {
  if (!risks || loading) return null;

  if (risks === 'None')
    return <RiskIcon title="No Risks Detected" data-testid="no-risk" color="success" />;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'row' }}>
      {Object.entries(risks).map(risk => {
        return (
          <Box key={risk[0]} sx={{ display: 'flex', alignItems: 'center' }}>
            <RiskIcon
              title={`${risk[0].charAt(0).toUpperCase() + risk[0].slice(1)} Risks Detected`}
              color={risk[0] === 'standard' ? 'warning' : 'error'}
              data-testid="risk"
            />
            <Typography variant="body2">{risk[1].length}</Typography>
          </Box>
        );
      })}
    </Box>
  );
}
